import { z } from "zod";

export const AccountRaidSchema = z.object({
  id: z.number().int().nonnegative(),
  name: z.string().nullable(),
  authPin: z.string().nullable(),
});

export type AccountRaid = z.infer<typeof AccountRaidSchema>;

export const AccountSchema = z.object({
  name: z.string().nullable(),
  raids: z.array(AccountRaidSchema),
});

export type Account = z.infer<typeof AccountSchema>;
